import React, { useEffect, useMemo } from "react";
import { Title, TextInput } from "@simplecitizen/gdl-react-ui-components";
import { useAppSelector } from "src/hooks/redux-hooks";
import { FieldErrors, useController } from "react-hook-form";

const BioGraphical = ({ control,errors }: { control: any, errors: FieldErrors<any>; }) => {
const {disableFirstName,disableLastName} = useAppSelector(state => state.document_validation)

  const profile = useAppSelector((state) => state.profileData);
  const { field: firstNameField } = useController({
    name: "firstName",
    control,
    rules: {
      required: "First Name is required.",
    },
  });
  
  const { field: middleNameField } = useController({
    name: "middleName",
    control,
  });
  
  const { field: lastNameField } = useController({
    name: "lastName",
    control,
    rules: {
      required: "Last Name is required.",
    },
  });

  useEffect(() => {
    if (profile) {
      firstNameField.onChange(profile.profile.name.firstName);
      middleNameField.onChange(profile.profile.name.middleName);
      lastNameField.onChange(profile.profile.name.lastName);
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);
  const fields = useMemo(() => {
    return [
      {
        label: "First name",
        disabled: disableFirstName,
        defaultValue: profile.profile.name.firstName,
        ...firstNameField,
      },
      {
        label: "Middle name",
        disabled: false,
        defaultValue: profile.profile.name.middleName,
        ...middleNameField,
      },
      {
        label: "Last name",
        defaultValue: profile.profile.name.lastName,
        disabled: disableLastName,
        ...lastNameField,
      },
    ];
  }, [firstNameField, middleNameField, lastNameField, profile,disableFirstName,disableLastName]);

  return (
    <div className="w-full">
      <Title>Biographical Information</Title>
      <p className="text-xs leading-none text-gray-500 italic">Please ensure your first, middle, and/or last name (as applicable) in this section match your full name as it appears on your passport.</p>
      <div className="mt-3">
        {fields.map(({ name, ...field }) => (
          <TextInput
          id={name}
          error_message={errors[name]?.message}
            key={name}
            className=""
            labelClassName="font-normal"
            name={name}
            autoComplete={
              name === "firstName"
                ? "given-name"
                : name === "middleName"
                ? "additional-name"
                : name === "lastName"
                ? "family-name"
                : undefined
            }
            {...field}
          />
        ))}
      </div>
    </div>
  );
};

export default BioGraphical;
